import styled from 'styled-components';
import { Field } from 'redux-form';
import { rgba } from 'polished';
import { Text } from '@omilia/typography';
import { colors } from '@omilia/theme';

// @ts-ignore
import Spinner from 'components/Spinner';

export const SRefIntentWrapper = styled.div`
  display: flex;
`;

export const SRefIntentContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const SSeparator = styled.span`
  font-size: 20px;
  height: 100%;
  line-height: 34px;
  padding: 0 4px;
`;

export const SText = styled(Text)`
  /* TODO: add color in ui-kit */
  background-color: #aab1c9;
  border-radius: 3px;
  color: ${colors.COLOR_WHITE};
  height: 34px;
  line-height: 34px;
  margin-bottom: 0;
  padding: 0 0 0 15px;
  width: 200px;
`;

export const SSpinner = styled(Spinner)`
  &&& {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

const SFormGroupTags = styled(Field)`
  &&& {
    display: block;
    position: relative;

    .react-tagsinput {
      /* TODO: add color in ui-kit */
      border: 1px solid #c9cdd7;
      border-radius: 4px;
      min-height: 34px;
      padding: 0;
      transition: box-shadow 0.5s, border-color 0.25s ease-in-out,
        -webkit-box-shadow 0.5s;
      width: 354px;

      input {
        border: none;
        color: ${colors.COLOR_GREY_1000};
        font-size: 12px;
        font-weight: 400;
        height: 32px;
        margin-bottom: 0;
        min-width: 100px;
        padding-left: 10px;
        width: 100%;

        &:focus {
          border: none;
          box-shadow: none;
          outline: none;
        }

        &[disabled] {
          visibility: hidden;
        }
      }
    }

    .react-autosuggest__container {
      display: flex;
      flex: 1;
    }

    .react-tagsinput-tag {
      /* TODO: add colors in ui-kit */
      background-color: #aab1c9;
      box-shadow: inset 0 -2px 0 0 #979eb8;
      border-radius: 2px;
      color: ${colors.COLOR_WHITE};
      font-size: 12px;
      font-weight: 400;
      height: 24px;
      line-height: 25px;
      margin: 5px 0 5px 10px;
      padding: 2px 0 2px 8px;
    }

    .react-tagsinput-remove {
      color: ${colors.COLOR_WHITE};
      font-size: 16px;
      font-weight: 300;
      margin: 0 4px;
      position: initial;
      transform: initial;
    }

    .react-autosuggest__suggestions-container--open {
      /* TODO: add color in ui-kit */
      background-color: ${colors.COLOR_WHITE};
      box-shadow: inset 0 1px 0 0 ${colors.COLOR_WHITE},
        0 2px 2px 0 ${rgba(`${colors.COLOR_WHITE}`, 0.1)};
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      border: 1px solid #c9cdd7;
      border-top: none;
      left: 0;
      margin-top: 31px;
      max-height: 144px;
      min-width: unset;
      overflow: auto;
      position: absolute;
      width: 100%;
      z-index: 999;

      ::-webkit-scrollbar-track {
        background-color: ${colors.COLOR_WHITE};
        border-bottom-right-radius: 4px;
      }
    }

    .react-autosuggest__suggestions-list {
      border: none;
      overflow-x: hidden;
    }

    .react-autosuggest__suggestion {
      padding: 0;
    }
  }
`;

export default SFormGroupTags;
